var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rgs-navigation-links"},_vm._l((_vm.list),function(block){return _c('navigation-links-block',{key:block.id,attrs:{"block":block}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }